<template>
  <form
    ref="form"
    class="standard-form"
    action="/my/account/export"
    method="post"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <div class="form-actions">
      <div class="form-action">
        <csrf-input />
        <submit-button
          type="submit"
          class="btn -main"
          :submitting="processing"
          label="Export Data Request"
          :submitting-label="submittingLabel"
          @submit-action="handleSubmit"
        />
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubmitButton from '../buttons/submit-button.vue'
import CsrfInput from '../forms/csrf-input.vue'

/**
 * Single button form to request data export
 */
export default defineComponent({
  name: 'ExportDataFOrm',
  components: {
    SubmitButton,
    CsrfInput,
  },
  props: {},
  data() {
    return {
      processing: false,
    }
  },
  computed: {
    submittingLabel() {
      return 'Processing...'
    },
  },
  methods: {
    // traditional form submit
    handleSubmit() {
      this.processing = true
      ;(this.$refs.form as HTMLFormElement).submit()
    },
  },
})
</script>
